/**
 * AnRa Stamped Bridge
 * Macht das native Ritual-rating-wrapper Element klickbar.
 * Beim Klick: smooth-scroll zum Stamped-Main-Widget (Produktseite) oder Carousel (Homepage-Fallback).
 */
(function () {
  function findStampedTarget() {
    return (
      document.getElementById('stamped-main-widget') ||
      document.querySelector('.stamped-main-widget') ||
      document.querySelector('[data-widget-style="standalone"]') ||
      document.getElementById('stamped-reviews-widget')
    );
  }

  function bindRatingClick() {
    const wrappers = document.querySelectorAll('.rating-wrapper:not([data-anra-stamped-bound])');
    wrappers.forEach(function (el) {
      el.setAttribute('data-anra-stamped-bound', 'true');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Bewertungen anzeigen');

      const handler = function (e) {
        const target = findStampedTarget();
        if (!target) return;
        e.preventDefault();
        const rect = target.getBoundingClientRect();
        const headerOffset = 80;
        const top = window.scrollY + rect.top - headerOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      };

      el.addEventListener('click', handler);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') handler(e);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindRatingClick);
  } else {
    bindRatingClick();
  }

  // Re-bind on Shopify section-render events (Customizer + dynamic loads)
  document.addEventListener('shopify:section:load', bindRatingClick);
})();
